import { mapServerToSpecificationsBase } from "./map-server-to-specifications-base.js";
import { getUnlocalizedSpecificationItem } from "../../../../utils/mappers/server-to-client/utils/get-unlocalized-specification-item.js";
import { getSpecificationItems } from "../../../../utils/mappers/server-to-client/utils/get-specification-items.js";
const mapServerToContactLensesSpecifications = (serverVariant, brand, replacementFrequency, replacementFrequencyAllLocales) => {
  const {
    packageQuantity,
    lensType,
    lensTypeAllLocales,
    material,
    materialAllLocales,
    materialType,
    waterContent
  } = serverVariant.variantTypeDetails;
  const lensTypeUnlocalized = getUnlocalizedSpecificationItem(lensTypeAllLocales);
  const materialUnlocalized = getUnlocalizedSpecificationItem(materialAllLocales);
  const replacementFrequencyUnlocalized = getUnlocalizedSpecificationItem(
    replacementFrequencyAllLocales
  );
  const serverSpecifications = {
    lensType,
    lensTypeUnlocalized,
    material,
    materialUnlocalized,
    materialType,
    packageQuantity,
    waterContent,
    replacementFrequency,
    replacementFrequencyUnlocalized
  };
  return [
    ...mapServerToSpecificationsBase(serverVariant, brand),
    ...getSpecificationItems(serverSpecifications)
  ];
};
export {
  mapServerToContactLensesSpecifications
};
//# sourceMappingURL=map-server-to-contact-lenses-specifications.js.map
